export default __webpack_public_path__ + "a241ba2d44b59512bd021a21c4b86cf7.png";